/* EB one-page quick order controller — LIVE + Funnel Build 2026-10-20.
   Vanilla JS, no dependencies. Powers every [data-eb-qo] block: product-card
   quick order (snippets/eb-quick-order.liquid) and the cart-drawer funnel rail
   cards (assets/eb-funnel.js) share this exact markup contract.
   Rule enforced here: the Add button stays disabled until a complete option
   set is chosen AND that exact variant exists AND is available. */
(function () {
  'use strict';

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function variantsOf(root) {
    if (root._ebVariants) return root._ebVariants;
    var el = root.querySelector('[data-eb-qo-variants]');
    var list = [];
    if (el) {
      try { list = JSON.parse(el.textContent); } catch (e) { list = []; }
    }
    root._ebVariants = list;
    return list;
  }

  function refresh(root) {
    var btn = root.querySelector('[data-eb-qo-add]');
    if (!btn) return;
    var variants = variantsOf(root);
    var selects = root.querySelectorAll('[data-eb-qo-select]');

    if (selects.length === 0) {
      /* Single default variant: nothing to choose. */
      var only = variants[0];
      if (!only) { btn.disabled = true; btn.textContent = 'Unavailable'; root._ebVariantId = null; return; }
      if (!only.a) { btn.disabled = true; btn.textContent = 'Sold Out'; root._ebVariantId = null; return; }
      btn.disabled = false;
      btn.textContent = 'Add to Cart \u2014 ' + money(only.p);
      root._ebVariantId = only.i;
      return;
    }

    var chosen = [];
    var complete = true;
    selects.forEach(function (s) {
      var idx = parseInt(s.getAttribute('data-option-index'), 10);
      chosen[idx] = s.value;
      if (!s.value) complete = false;
    });
    if (!complete) {
      btn.disabled = true;
      btn.textContent = 'Add to Cart';
      root._ebVariantId = null;
      return;
    }
    var match = null;
    variants.forEach(function (v) {
      if (v.o.length === chosen.length && v.o.every(function (val, i) { return val === chosen[i]; })) match = v;
    });
    if (!match) { btn.disabled = true; btn.textContent = 'Unavailable'; root._ebVariantId = null; return; }
    if (!match.a) { btn.disabled = true; btn.textContent = 'Sold Out'; root._ebVariantId = null; return; }
    btn.disabled = false;
    btn.textContent = 'Add to Cart \u2014 ' + money(match.p);
    root._ebVariantId = match.i;
  }

  function refreshAll(scope) {
    (scope || document).querySelectorAll('[data-eb-qo]').forEach(refresh);
  }

  function showMsg(root, text) {
    var msg = root.querySelector('[data-eb-qo-msg]');
    if (msg) { msg.textContent = text; msg.hidden = !text; }
  }

  function openCartDrawer() {
    if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart) {
      if (typeof Shopify.theme.jsAjaxCart.updateView === 'function') Shopify.theme.jsAjaxCart.updateView();
      if (typeof Shopify.theme.jsAjaxCart.showDrawer === 'function') Shopify.theme.jsAjaxCart.showDrawer();
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-eb-qo-select]') : null;
    if (!sel) return;
    var root = sel.closest('[data-eb-qo]');
    if (root) { showMsg(root, ''); refresh(root); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-eb-qo-add]') : null;
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-eb-qo]');
    if (!root || !root._ebVariantId) return;
    var id = root._ebVariantId;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      }
      return r.json();
    }).then(function () {
      btn.textContent = 'Added \u2713';
      openCartDrawer();
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1200);
    }).catch(function (err) {
      showMsg(root, (err && err.message) || 'Could not add to cart');
      btn.textContent = label;
      btn.disabled = false;
    });
  });

  /* Cards injected later (infinite-scroll grids, drawer refreshes) get
     initialised by a light observer. */
  var rafPending = false;
  var obs = new MutationObserver(function (mutations) {
    var hasNew = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.hasAttribute && (n.hasAttribute('data-eb-qo') || n.querySelector('[data-eb-qo]'))) hasNew = true;
      });
    });
    if (!hasNew || rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; refreshAll(); });
  });

  function init() {
    refreshAll();
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.EBQuickOrder = { refreshAll: refreshAll, refresh: refresh };
})();
